import { styled } from 'parkdepot-shared/theme'
import { Link } from 'react-router-dom'

export const FormContainer = styled('div', () => ({
    margin: '2.4rem 0',
    display: 'flex',
    flexDirection: 'column',
    gap: '2.4rem'
}))

export const InputContainer = styled<'input', { $error?: boolean }>('input', ({ $theme, $error = false }) => ({
    height: '5rem',
    padding: '1.2rem 2rem',
    width: '100%',
    border: `1px solid  ${$error ? '#D92D20' : '#EAECF0'}`,
    backgroundColor: $theme.colors.white,
    color: $theme.colors.black,
    outline: 'none',
    borderRadius: '2.4rem',

    '::placeholder': {
        color: '#B3BBC7'
    }
}))

export const InputPlaceholder = styled('label', ({ $theme }) => ({
    ...$theme.typography.ParagraphXSmall,
    fontWeight: 300,
    marginBottom: '4px',
    display: 'block',
    color: '#667085'
}))

export const Title = styled('div', ({ $theme }) => ({
    marginTop: '2rem'
}))

export const LoginErrorText = styled('div', ({ $theme }) => ({
    color: '#D92D20',
    marginTop: '-1.2rem',
    fontSize: '1.2rem'
}))

export const SeePasswordIcon = styled('i', ({ $theme }) => ({
    position: 'absolute',
    right: '1.6rem',
    bottom: '1.3rem',
    fontSize: '2.4rem',
    cursor: 'pointer',
    color: $theme.colors.primary
}))
